import { render } from "./one-time-password.vue?vue&type=template&id=f76e296e"
import script from "./one-time-password.vue?vue&type=script&lang=js"
export * from "./one-time-password.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__